/**
 * ThinkSpace Brand Colors
 * Purple/Pink gradient theme aligned with logo
 */
export const brandColors = {
  // Core brand colors
  purple: '#B049B6',
  purpleDeep: '#9A349D',
  pink: '#F34788',
  yellow: '#FBBE4D',
  charcoal: '#444E54',
  gray: '#8E9498',
  lilac: '#D5ADD3',

  // Background colors
  bg: '#FDFCFD',
  paper: '#FFFFFF',
  surface: '#FBF7FB', // subtle lilac-tinted surface

  // Primary palette
  primary: {
    main: '#B049B6',
    light: '#C76DCC',
    dark: '#9A349D',
    contrastText: '#FFFFFF',
  },

  // Secondary palette
  secondary: {
    main: '#F34788',
    light: '#F66FA3',
    dark: '#D13070',
    contrastText: '#FFFFFF',
  },

  // Accent colors
  accent: {
    yellow: '#FBBE4D',
    green: '#4CAF50',
    red: '#EF5350',
  },

  // Neutrals
  neutral: {
    black: '#444E54',
    darkGray: '#5A6268',
    gray: '#8E9498',
    lightGray: '#F5F5F5',
    white: '#FFFFFF',
  },

  // Gradient
  gradient: 'linear-gradient(135deg, #F34788 0%, #B049B6 55%, #9A349D 100%)',
} as const;
